<!-- 该案例暂时不提供 -->
<template>
  <div>NA</div>
</template>

<style src="@/assets/css/cases.css" scoped></style>
